import {
  CloudflareImageProcessor,
  ImageProcessorProviderProps,
} from "@made-people/grease-image";

const cloudflareBaseUrl = "https://assets.missmaryofsweden.com";
export const cloudflareImageProcessor = new CloudflareImageProcessor(
  cloudflareBaseUrl,
);

export const imageProcessorProps: ImageProcessorProviderProps = {
  processors: [
    // new StoryblokImageProcessor(),
    cloudflareImageProcessor, // Just using cloudflare is faster for storyblok as well
  ],
};
